import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";


import {
    FormGroup,
    Label,

} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import {
    contractUpdateEnrolment,
} from 'Actions';


class UpdateStudents1 extends React.Component {

    constructor(props) {
        super(props);
        console.log(props, "edit enrolment")
        this.state = {
            student: this.props.particularcontractstudent.student[0],
            parent: this.props.particularcontractstudent.parent[0],
            parentid: this.props.particularcontractstudent.student[0].uud_pid,
            exstudentid: this.props.particularcontractstudent.student[0].uudID,
            edcontactid: this.props.particularcontractstudent.student[0].uud_ctID
        };
        this.addHandleSubmit = this.addHandleSubmit.bind(this);
    }

    addHandleSubmit(event) {
        event.preventDefault();

        const formData = new FormData(event.target);

        const requestBody = {
            studentfname: formData.get('studentfname'),
            studentlname: formData.get('studentlname'),
            studentemail: formData.get('studentemail'),
            studentmobile: formData.get('studentphone'),
            studentdob: formData.get('studentdob'),
            studentblood: formData.get('studentbloodgroup'),
            studentfood: formData.get('studentfoodpref'),
            studentfoodallg: formData.get('studentfoodallergies'),
            studentmedical: formData.get('studentmedical'),
            studentinformation: formData.get('otherinfo'),
            parentfname: formData.get('parentfname'),
            parentlname: formData.get('parentlname'),
            parentemail: formData.get('parentemail'),
            parentmobile: formData.get('parentphone'),
            parentage: formData.get('parentdob'),
            address: formData.get('parentaddress'),
            parentid: this.state.parentid,
            exstudentid: this.state.exstudentid,
            edcontactid: this.state.edcontactid
        };

        this.props.contractUpdateEnrolment(requestBody).then((data) => {
            if (data.status === 1) {
                this.setState({
                    student: '',
                    seldate: '',
                });

                document.getElementById("addform").reset();
            }
        });
    }

    render() {
        return (
            <>
                <div className="row gx-3">
                    <div className="col-sm-12 col-lg-8" style={{margin:"0 auto"}}>
                        <form autoComplete="off" id="addform" onSubmit={(e) => this.addHandleSubmit(e)}>
                            <RctCollapsibleCard
                                heading={
                                    <div style={{ display: 'flex', alignItems: 'center', borderBottom: "1px solid #ccc" }}>
                                        <span>Edit Enrolment Details</span>
                                        <button type="button" className="mr-10 mb-10 btn btn-outline-warning ml-auto" onClick={this.props.onClick}>Back</button>
                                    </div>
                                }
                            >
                                <div className='row'>
                                    <div className='col-lg-6'>
                                        <div className="ss">
                                        <h3>Student Details:</h3>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative">
                                                <input
                                                    className="form-control"
                                                    placeholder="Student First Name"
                                                    name="studentfname"
                                                    id="edstudentfname"
                                                    type="text"
                                                    value={this.state.student.uud_firstName}
                                                    onChange={(e) => this.setState({ student: { ...this.state.student, uud_firstName: e.target.value } })}
                                                    autoComplete="off"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative">
                                                <input
                                                    className="form-control"
                                                    placeholder="Student Last Name"
                                                    name="studentlname"
                                                    id="edstudentlname"
                                                    type="text"
                                                    value={this.state.student.uud_lastName}
                                                    onChange={(e) => this.setState({ student: { ...this.state.student, uud_lastName: e.target.value } })}
                                                    autoComplete="off"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative">
                                                <input
                                                    className="form-control"
                                                    placeholder="Email"
                                                    name="studentemail"
                                                    id="edstudentemail"
                                                    type="text"
                                                    value={this.state.student.uud_email}
                                                    onChange={(e) => this.setState({ student: { ...this.state.student, uud_email: e.target.value } })}
                                                    autoComplete="off"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative">
                                                <input
                                                    className="form-control"
                                                    placeholder="Phone Number"
                                                    name="studentphone"
                                                    id="edstudentphone"
                                                    type="text"
                                                    value={this.state.student.uud_phone}
                                                    onChange={(e) => this.setState({ student: { ...this.state.student, uud_phone: e.target.value } })}
                                                    autoComplete="off"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative">
                                                <input
                                                    className="form-control"
                                                    placeholder="Date of Birth"
                                                    name="studentdob"
                                                    id="edstudentdob"
                                                    type="text"
                                                    value={this.state.student.uud_dob}
                                                    onChange={(e) => this.setState({ student: { ...this.state.student, uud_dob: e.target.value } })}
                                                    autoComplete="off"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative">
                                                <input
                                                    className="form-control"
                                                    placeholder="Student Blood Group"
                                                    name="studentbloodgroup"
                                                    id="edstudentbloodgroup"
                                                    value={this.state.student.ctsd_bloodgroup}
                                                    onChange={(e) =>
                                                        this.setState({
                                                            student: {
                                                                ...this.state.student,
                                                                ctsd_bloodgroup: e.target.value,
                                                            },
                                                        })
                                                    }
                                                    type="text"
                                                    autoComplete="off"
                                                   
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative">
                                                <input
                                                    className="form-control"
                                                    placeholder="Student Food Preferences"
                                                    name="studentfoodpref"
                                                    id="edstudentfoodpref"
                                                    value={this.state.student.ctsd_food}
                                                    onChange={(e) =>
                                                        this.setState({
                                                            student: {
                                                                ...this.state.student,
                                                                ctsd_food: e.target.value,
                                                            },
                                                        })
                                                    }
                                                    type="text"
                                                    autoComplete="off"
                                                    
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative">
                                                <input
                                                    className="form-control"
                                                    placeholder="Student Food Allergies"
                                                    name="studentfoodallergies"
                                                    id="edstudentfoodallergies"
                                                    value={this.state.student.ctsd_foodallergies}
                                                    onChange={(e) =>
                                                        this.setState({
                                                            student: {
                                                                ...this.state.student,
                                                                ctsd_foodallergies: e.target.value,
                                                            },
                                                        })
                                                    }
                                                    type="text"
                                                    autoComplete="off"
                                                    
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative">
                                                <input
                                                    className="form-control"
                                                    placeholder="Student Medical Conditions"
                                                    name="studentmedical"
                                                    id="edstudentmedical"
                                                    value={this.state.student.ctsd_medical}
                                                    onChange={(e) =>
                                                        this.setState({
                                                            student: { ...this.state.student, ctsd_medical: e.target.value },
                                                        })
                                                    }
                                                    type="text"
                                                    autoComplete="off"
                                                   
                                                />
                                            </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                        <textarea rows="3" type="text" name="otherinfo" id="otherinfo"  value={this.state.student.ctsd_otherdetails}
                                                    onChange={(e) =>
                                                        this.setState({
                                                            student: { ...this.state.student, ctsd_otherdetails: e.target.value },
                                                        })
                                                    } className="form-control form-control-alternative"></textarea>
                                        </div>
                                    </div>
                                    <div className='col-lg-6'>
                                        <div className="dd">
                                        <h3>Parent Details:</h3>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative">
                                                <input
                                                    className="form-control"
                                                    placeholder="First Name"
                                                    name="parentfname"
                                                    id="edparentfname"
                                                    value={this.state.parent.uud_firstName}
                                                    type="text"
                                                    autoComplete="off"
                                                    required
                                                    onChange={(e) => this.setState({ parent: { ...this.state.parent, uud_firstName: e.target.value } })}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative">
                                                <input
                                                    className="form-control"
                                                    placeholder="Last Name"
                                                    name="parentlname"
                                                    id="edparentlname"
                                                    value={this.state.parent.uud_lastName}
                                                    type="text"
                                                    autoComplete="off"
                                                    required
                                                    onChange={(e) => this.setState({ parent: { ...this.state.parent, uud_lastName: e.target.value } })}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative">
                                                <input
                                                    className="form-control"
                                                    placeholder="Email"
                                                    name="parentemail"
                                                    id="edparentemail"
                                                    value={this.state.parent.uud_email}
                                                    type="email"
                                                    autoComplete="off"
                                                    required
                                                    onChange={(e) => this.setState({ parent: { ...this.state.parent, uud_email: e.target.value } })}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative">
                                                <input
                                                    className="form-control"
                                                    placeholder="Phone"
                                                    name="parentphone" 
                                                    id="edparentphone" 
                                                    value={this.state.parent.uud_phone}
                                                    type="tel"
                                                    autoComplete="off"
                                                    required
                                                    onChange={(e) => this.setState({ parent: { ...this.state.parent, uud_phone: e.target.value } })}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative">
                                                <input
                                                    className="form-control"
                                                    placeholder="Date of Birth"
                                                    name="parentdob"
                                                    id="edparentdob"
                                                    value={this.state.parent.uud_dob}
                                                    type="date"
                                                    autoComplete="off"
                                                    required
                                                    onChange={(e) => this.setState({ parent: { ...this.state.parent, uud_dob: e.target.value } })}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative">
                                                <input
                                                    className="form-control"
                                                    placeholder="Address"
                                                    name="parentaddress"
                                                    id="edparentaddress"
                                                    value={this.state.parent.uud_address}
                                                    type="text"
                                                    autoComplete="off"
                                                    required
                                                    onChange={(e) => this.setState({ parent: { ...this.state.parent, uud_address: e.target.value } })}
                                                />
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-center">
                                    <button className="btn btn-primary" >Update</button>
                                </div>
                            </RctCollapsibleCard>
                        </form>
                    </div>
                </div>
            </>
        )
    }
}
const mapStateToProps = ({ contractstudent }) => {
    const { particularcontractstudent, travelformmail, loading } = contractstudent;
    return { particularcontractstudent, travelformmail, loading };

}

export default connect(mapStateToProps, {
    contractUpdateEnrolment,
})(UpdateStudents1);